
import Component from './Component'

/**
 * Base class for all the section components
 *
 * All components should inherit this class and implement what method they need
 */
export default class Section extends Component {
  /**
     *
     * @param {import("./ThemeBase").default} theme Global theme object
     * @param {HTMLElement} element Toplevel element for the section
     * @param {boolean} pageLoad True on initial page load, False when this section reloads
     */
  constructor(theme, element, pageLoad) {
    super(theme, element);

    this.theme = theme;
    this.element = element;
  }

    /**
     * This will be called when section gets selected in Shopify Theme Editor
     *
     * @param {Object} params
     * @param {HTMLElement} params.element Toplevel element for the section
     * @param {string} params.sectionId Identification of the section
     * @param {boolean} params.load True if block was loaded, False if user just openeded previously selected block
     * */
    onSectionSelect = ({ element, sectionId, load }) => {
    }

    /**
     * This will be called when section gets deselected in Shopify Theme Editor
     *
     * @param {Object} params
     * @param {HTMLElement} params.element Toplevel element for the section
     * @param {string} params.sectionId Identification of the section
     */
    onSectionDeselect = ({ element, sectionId }) => {
    }

    /**
     * This will be called when section user reorders this section in Shopify Theme Editor
     *
     * @param {Object} params
     * @param {HTMLElement} params.element Toplevel element for the section
     * @param {string} params.sectionId Identification of the section
     */
    onSectionReorder = ({ element, sectionId }) => {
    }

    /**
     * This will be called when block gets selected in Shopify Theme Editor
     *
     * @param {Object} params
     * @param {HTMLElement} params.element Toplevel element for the block
     * @param {string} params.sectionId Identification of the section
     * @param {string} params.blockId Identification of the block
     * @param {boolean} params.load True if block was loaded, False if user just openeded previously selected block
     * */
    onBlockSelect = ({ element, sectionId, blockId, load }) => {
    }

    /**
     * This will be called when block gets deselected in Shopify Theme Editor
     *
     * @param {Object} params
     * @param {HTMLElement} params.element Toplevel element for the block
     * @param {string} params.sectionId Identification of the section
     * @param {string} params.blockId Identification of the block
     * */
    onBlockDeselect = ({ element, sectionId, blockId }) => {
    }

    /**
     * This will be called when section is detached from DOM (usually when removed/reconfigured in Theme Editor)
     *
     * @param {Object} params
     * @param {HTMLElement} params.element Toplevel element for the section that's being destroyed
     */
    destroy = ({ element }) => {
    }
}
